import React, {MouseEvent, ReactElement, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {DbUserService} from "app/services/db/dbUserService";
import {ResponseResultCode} from "app/model/response-api";
import {PstatModel} from "app/model/info/pstat";
import moment from "moment/moment";
import DashboardLoading from "./DashboardLoading";
import DashboardNoData from "./DashboardNoData";
import {DashboardModuleProps} from "app/model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

export default function NoticeNews(props: Readonly<DashboardModuleProps>) {
  const navigate = useNavigate();
  const [notice, setNotice] = useState<ReactElement[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    DbUserService.getInstance().fetchRecentNotice().then(response => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        if (response.data && response.data.length > 0) {
          setNotice(response.data.map((f, i) => templateNoticeBox(f, i)))
        }
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);

  function templateNoticeBox(data: PstatModel, index: number) {
    const today = moment().format('YYYY-MM-DD');
    const regDt = moment(data.regDate).format('YYYY-MM-DD');
    return (
      <li key={data.pstatId}>
        <span>
          {today === regDt && (<strong className="new">N</strong>)}
          {data.titlNm}
          <Link to="#" onClick={(e) => handleClickLi(e, data)} style={{position: 'absolute', width: '100%', height: '100%', top: 0, left: 0}}></Link>
        </span>
        <span>{moment(data.regDate).format('YYYY-MM-DD')}</span>
      </li>
    )
  }

  function handleClickLi(e: MouseEvent<HTMLAnchorElement>, data: any) {
    e.preventDefault();
    navigate("/info/info001/detail", {state: data});
  }

  function handleClickMoreBtn(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    navigate('/info/info001');
  }

  return (
    <DashboardCard
      title="공지사항"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/info/info001"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      <div className="notice-wrap">
        {(notice && notice.length > 0) ? (
          <ul className="dash-list2">
            {notice.map((item: any) => item)}
          </ul>
        ) : (
          <DashboardNoData message="등록된 글이 없습니다." />
        )}
      </div>
    </DashboardCard>
  );
}